import { useSettings } from '../context/SettingsContext';
import parse from "html-react-parser";

export enum SettingsEnum {
    TOP_SEARCHES_EN = 'top_searches_en',
    TOP_SEARCHES_ES = 'top_searches_es',
    SITE_FOOTER_EN = "site_footer_en",
    SITE_FOOTER_ES = "site_footer_es",
    EXIT_DISCLAIMER_HTML = "exit_disclaimer_html",
    EXIT_DISCLAIMER_HTML_SPANISH = "exit_disclaimer_html_es",
    EXIT_DISCLAIMER_EXCLUDE_LINKS = "exit_disclaimer_exclude_links",
    LPL_DISCLOSURE_HTML = "lpl_disclosure_html",
    LPL_DISCLOSURE_HTML_SPANISH = "lpl_disclosure_html_es",
    LPL_DISCLOSURE_PATHS = "lpl_disclosure_paths",
    BLOG_CATEGORIES = "blog_categories",
}

export const getSetting = (setting:SettingsEnum) => {
    const settings = useSettings();
  
    return settings[setting];
}

export const getSettingAsObject = (setting:SettingsEnum) => {
    const settings = useSettings();
    let settingEntry = settings[setting];

    if (!settingEntry) {
        return {}
    }

    if (typeof(settingEntry) === 'object') {
        return settingEntry;
    }

    try {
        settingEntry = JSON.parse(settingEntry);
    } catch (error) {
        settingEntry = {};
        console.error(error);
    }   
  
    return settingEntry;
}

export function getSettingAsDelimitedList(setting: SettingsEnum) {
    const settings = useSettings();
    let settingEntry = settings[setting];
    try {
        return settingEntry
            .toLowerCase()
            .split(/[\n,]/)
            .map(path => path.replace(/\r/, "").trim())
            .filter(path => Boolean(path));
    } catch (error) {
        console.error(`error parsing ${setting} in getSettingAsDelimitedList`, error);
        return [];
    }
}

export function getSettingAsHtml(setting: SettingsEnum) {
    const settings = useSettings();
    let settingEntry = settings[setting];
    try {
        return parse(settingEntry);
    } catch (error) {
        console.error(`error parsing ${setting} in getValueAsHtml`, error);
        return '';
    }
}
